//import { any, func, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

// const handleColorType = (module, theme) => {
// 	switch (module.toLowerCase()) {
// 		case 'storage':
// 			return theme.storage;
// 		case 'account':
// 			return theme.account;
// 		case 'billing':
// 			return theme.billing;
// 		case 'support':
// 			return theme.support;
// 		default:
// 			return theme.main;
// 	}
// };

const SettingsStyle = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	text-align: center;
	display: flex;
	color: ${props => props.theme.Cool_Gray_Med_1};

	.selection-container {
		min-width: 120px;
		display: flex;
		justify-content: center;
		.settings-selections {
			.selection {
				display: flex;
				flex-direction: column;
				justify-content: center;
				width: 72px;
				height: 48px;
				margin-bottom: 16px;
				background: ${props => props.theme.componentBackground};
				cursor: pointer;

				&.active {
					background: ${props => props.theme.account};
					color: ${props => props.theme.white};
				}
			}
		}
	}
	.main-container {
		padding: 24px 32px 40px;
		max-width: 496px;
		min-width: 496px;
		height: 296px;
		background-color: ${props => props.theme.componentBackground};
		&.large {
			min-width: 622px;
			height: 348px;
		}

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}
		.page {
			height: 100%;
			.avatar-display {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				.image {
					margin-top: 30px;
				}

				.avatar-button {
					position: absolute;
					bottom: 64px;
				}
			}
		}
		.header-container-wrapper-top {
			position: absolute;
			right: 8px;
			top: -24px;
			.header-selection-container {
				width: 80px;
				height: 24px;
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				background: ${props => props.theme.componentBackground};
				&.selected {
					background: ${props => props.theme.account};
					color: ${props => props.theme.white};
				}
			}
		}

		.header-container-wrapper {
			display: flex;
			align-content: center;
			justify-content: center;
			height: 38px;
			.header-selection-container {
				margin: 0px;
				display: flex;
				align-content: center;
				justify-content: center;
			}
			.header-title-wrapper {
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
			.header-title {
				width: 100%;
				white-space: nowrap;
				display: flex;
				align-items: center;
				justify-content: center;
				padding-right: 20px;
				padding-left: 20px;
				border-right: 1px solid ${props => props.theme.Cool_Gray_Med_2};
				img {
					width: 20px;
					height: 20px;
					margin-left: 5px;
					&.show {
						transform: rotate(180deg);
					}
				}
				&.selected {
					color: ${props => props.theme.account};
					//border: 1px solid ${props => props.theme.Cool_Gray_Med_2};
				}
			}
			.header-selection-container:last-child {
				.header-title {
					border: none;
				}
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		position: relative;
		width: 544px;
		height: 344px;
		text-align: center;
		display: flex;
		color: ${props => props.theme.Cool_Gray_Med_1};

		.selection-container {
			min-width: 144px;
			display: flex;
			justify-content: center;
			.settings-selections {
				.selection {
					display: flex;
					flex-direction: column;
					justify-content: center;
					width: 96px;
					height: 64px;
					margin-bottom: 16px;
					background: ${props => props.theme.componentBackground};
					cursor: pointer;

					&.active {
						background: ${props => props.theme.account};
						color: ${props => props.theme.white};
					}
				}
			}
		}
		.main-container {
			padding: 24px 40px 40px;
			min-width: 588px;
			height: 368px;
			&.large {
				min-width: 735px;
				height: 400px;
			}

			.divider {
				width: 100%;
				height: 2px;
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.boxShadow}inset;
			}
			.page {
				height: 100%;
				.avatar-display {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					.image {
						margin-top: 30px;
					}

					.avatar-button {
						position: absolute;
						bottom: 64px;
					}
				}
			}
			.header-container-wrapper-top {
				position: absolute;
				right: -188px;
				top: -24px;
				.header-selection-container {
					width: 80px;
					height: 24px;
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: center;
					background: ${props => props.theme.componentBackground};
					&.selected {
						background: ${props => props.theme.account};
						color: ${props => props.theme.white};
					}
				}
			}
			.header-container-wrapper {
				display: flex;
				align-content: center;
				justify-content: center;
				height: 32px;
				.header-selection-container {
					margin: 0px;
					display: flex;
					align-content: center;
					justify-content: center;
				}
				.header-title-wrapper {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
				.header-title {
					width: 100%;
					white-space: nowrap;
					display: flex;
					align-items: center;
					justify-content: center;
					padding-right: 20px;
					padding-left: 20px;
					border-right: 1px solid ${props => props.theme.Cool_Gray_Med_2};
					img {
						width: 20px;
						height: 20px;
						margin-left: 5px;
						&.show {
							transform: rotate(180deg);
						}
					}
				}
				.header-selection-container:last-child {
					.header-title {
						border: none;
					}
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		position: relative;
		width: 1025px;
		height: 344px;
		text-align: center;
		display: flex;
		color: ${props => props.theme.Cool_Gray_Med_1};

		.selection-container {
			min-width: 208px;
			display: flex;
			justify-content: center;

			.settings-selections {
				.selection {
					display: flex;
					flex-direction: column;
					justify-content: center;
					width: 128px;
					height: 80px;
					margin-bottom: 24px;
					background: ${props => props.theme.componentBackground};
					cursor: pointer;

					&.active {
						background: ${props => props.theme.account};
						color: ${props => props.theme.white};
					}
				}
			}
		}

		.main-container {
			padding: 24px 40px 40px;
			min-width: 1339px;
			height: 496px;
			position: relative;
			&.large {
				min-width: 1231px;
				height: 592px;
			}

			.divider {
				width: 100%;
				height: 2px;
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.boxShadow} inset;
			}
			.page {
				height: 100%;
				.avatar-display {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					.image {
						margin-top: 60px;
						img {
							width: 200px;
							height: 200px;
						}
					}

					.avatar-button {
						position: absolute;
						bottom: 64px;
					}
				}
			}
			.header-container-wrapper-top {
				position: absolute;
				right: 0px;
				top: -32px;
				.header-selection-container {
					width: 112px;
					height: 32px;
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: center;
					background: ${props => props.theme.componentBackground};
					&.selected {
						background: ${props => props.theme.account};
						color: ${props => props.theme.white};
					}
				}
			}

			.header-container-wrapper {
				display: flex;
				align-content: center;
				justify-content: center;
				height: 38px;
				.header-selection-container {
					margin: 0px;
					display: flex;
					align-content: center;
					justify-content: center;
				}
				.header-title-wrapper {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
				.header-title {
					width: 100%;
					white-space: nowrap;
					display: flex;
					align-items: center;
					justify-content: center;
					padding-right: 20px;
					padding-left: 20px;
					border-right: 1px solid ${props => props.theme.Cool_Gray_Med_2};
					img {
						width: 20px;
						height: 20px;
						margin-left: 5px;
						&.show {
							transform: rotate(180deg);
						}
					}
				}
				.header-selection-container:last-child {
					.header-title {
						border: none;
					}
				}
			}
		}
	}
`;

export const Settings = ({
	className,
	id,
	onMouseOver,
	module,
	showTopSelections,
	settingSelections,
	headerSelections,
	selectedPage,
	selectedPageValue,
	onSelectionClick,
	onHeaderClick,
	includeSelection,
	selectedSection,
}) => {
	function renderHeaderSelections(headerSelections) {
		return headerSelections.map((selection, index) => {
			return (
				<div
					className={
						selection?.value === selectedPageValue
							? 'header-selection-container selected'
							: 'header-selection-container'
					}
				>
					<div
						className='header-title-wrapper'
						data-cy={`header-selection-${index}`}
						id={`header-selection-${index}`}
						onClick={() => onHeaderClick(selection?.value)}
					>
						<div
							className={
								selection?.value === selectedPageValue
									? 'header-title selected heading60'
									: 'header-title heading60'
							}
						>
							{selection?.label}
						</div>
					</div>
				</div>
			);
		});
	}

	const renderTopSelections = showTopSelections ? true : false;

	return (
		<SettingsStyle id={id} className={className} onMouseOver={onMouseOver} module={module}>
			{includeSelection && (
				<div className='selection-container'>
					<ScrollView>
						<div className='settings-selections'>
							{settingSelections &&
								settingSelections.map(selection => (
									<div
										className={
											selection?.value === selectedSection
												? 'selection active body10'
												: 'selection body10'
										}
										onClick={() => onSelectionClick(selection?.value)}
									>
										<div className='title'>{selection?.label}</div>
									</div>
								))}
						</div>
					</ScrollView>
				</div>
			)}
			<div className={includeSelection ? 'main-container' : 'main-container large'}>
				{headerSelections && !renderTopSelections && (
					<>
						<div className='divider'></div>
						<div className='header-container-wrapper' id='header-container-wrapper'>
							{renderHeaderSelections(headerSelections)}
						</div>
						<div className='divider'></div>
					</>
				)}
				{headerSelections && renderTopSelections && (
					<div className='header-container-wrapper-top' id='header-container-wrapper-top'>
						{renderHeaderSelections(headerSelections)}
					</div>
				)}

				<div className='page'> {selectedPage}</div>
			</div>
		</SettingsStyle>
	);
};
// ActionButton.propTypes = {
// 	children: any,
// 	className: string,
// 	id: string,
// 	onClick: func,
// 	onMouseOver: func,
// 	module: string,
// };

// ActionButton.defaultProps = {
// 	children: '',
// 	className: 'action-button',
// 	id: 'action-button',
// 	onClick: () => {},
// 	onMouseOver: () => {},
// 	module: 'support',
// };
